/**
 * This code is extracted from Slate
 */

import Dom from "../tools/dom";

export default class SectionContainer {
  constructor() {
    this.constructors = [];
    this.instances = [];

    this._attachListeners();
  }

  _attachListeners() {
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:section:reorder', this._onReorder.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  }
  register(type, constructor) {
    var _this58 = this;

    this.constructors[type] = constructor;

    Dom.nodeListToArray(document.querySelectorAll('[data-section-type=' + type + ']')).forEach(function (container) {
      _this58._createInstance(container, constructor);
    });
  }

  /**
   * Return an object from an array of objects that matches the provided key and value
   */

  _findInstance(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  }

  /**
   * Remove an object from an array of objects by matching the provided key and value
   */

  _removeInstance(array, key, value) {
    var i = array.length;

    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  }
  _onSectionLoad(event) {
    var container = event.target.querySelector('[data-section-id]');

    if (container) {
      this._createInstance(container);
    }
  }
  _onSectionUnload(event) {
    var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(event);
    }

    this.instances = this._removeInstance(this.instances, 'id', event.detail.sectionId);
  }
  _onSelect(event) {
    var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(event);
    }
  }
  _onDeselect(event) {
    var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(event);
    }
  }
  _onReorder(event) {
    var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(event);
    }
  }
  _onBlockSelect(event) {
    var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(event);
    }
  }
  _onBlockDeselect(event) {
    var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(event);
    }
  }
  _createInstance(container, constructor) {
    var id = container.getAttribute('data-section-id'),
        type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  }
}